import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetQuotesByOrder as useGetQuotesByOrderClient } from './quotes.ts';

export function getUseGetQuotesByOrderQueryKey(orderId: string) {
    return ['quotes-by-order', orderId];
}

export const useGetQuotesByOrder = (orderId: string) => {
    const { getQuotesByOrder } = useGetQuotesByOrderClient();

    return useSuspenseQuery({
        queryKey: getUseGetQuotesByOrderQueryKey(orderId),
        queryFn: () => getQuotesByOrder(orderId),
    });
};
